import { useAppConstantsContext } from '@ltvco/refresh-lib/ctx';
import { Stack, Box } from '@ltvco/refresh-lib/theme';
import { FcraWarning, SearchData } from '@ltvco/refresh-lib/v1';
import { WhereIsMyVINModal } from '@ltvco/refresh-lib/v2';
import React, { useState, useEffect } from 'react';

import {
  DisclaimerText,
  HeaderText,
  SearchHubContainer,
  StyledTabMobile,
  StyledTabsMobile,
} from './components';
import {
  SearchTabType,
  getPlaceholderText,
  renderSearchForm,
  SubheaderText,
} from './utils';

interface MobileSearchHubProps {
  // eslint-disable-next-line no-unused-vars
  onSearchSuccess: (data: SearchData) => void;
  placement?: string;
  searchTabs: SearchTabType[];
  activeTab?: string;
  // eslint-disable-next-line no-unused-vars
  onTabChange?: (event: React.SyntheticEvent, newValue: string) => void;
}

export const MobileSearchHub: React.FC<MobileSearchHubProps> = ({
  onSearchSuccess,
  placement = 'dashboard',
  searchTabs,
  activeTab,
  onTabChange,
}) => {
  const [placeholderText, setPlaceholderText] = useState<string>('');
  const [subheaderText, setSubheaderText] = useState<string>('');
  const [isVINModalOpen, setIsVINModalOpen] = useState<boolean>(false);
  const {
    data: { brandName },
    links: { fcraLink, tosLink },
  } = useAppConstantsContext();
  const displayDisclaimer = activeTab === 'peopleTab';
  const isVehicleTab = activeTab === 'vehicleTab';

  useEffect(() => {
    if (searchTabs.length > 0) {
      updateTabContent(activeTab, searchTabs);
    }
  }, [activeTab, searchTabs]);

  const updateTabContent = (tabId: string = '', tabs: SearchTabType[]) => {
    const activeTabData = tabs.find((tab) => tab.id === tabId);
    if (activeTabData) {
      setSubheaderText(activeTabData.subheaderText);
      setPlaceholderText(getPlaceholderText(tabId, true));
    }
  };

  const tabDisplayName = (displayName: string) => {
    if (displayName.toLocaleLowerCase() === 'people') {
      return 'Person';
    }

    return displayName;
  };

  return (
    <Stack spacing={2} mx={0} my={0} marginTop={0}>
      <SearchHubContainer position="relative">
        <HeaderText variant="h1">What will you search for?</HeaderText>

        <Box sx={{ width: '100%' }}>
          <StyledTabsMobile
            value={activeTab}
            onChange={onTabChange}
            variant="standard"
            sx={{ justifyContent: 'space-between' }}
            scrollButtons={false}
            TabIndicatorProps={{ style: { display: 'none' } }}
          >
            {searchTabs.map((tab) => (
              <StyledTabMobile
                key={tab.id}
                value={tab.id}
                label={tabDisplayName(tab.displayName)}
                icon={tab.icon}
                disableRipple
              />
            ))}
          </StyledTabsMobile>
        </Box>

        {renderSearchForm(
          activeTab,
          placeholderText,
          onSearchSuccess,
          placement,
          true
        )}

        <SubheaderText
          subheaderText={subheaderText}
          isPhoneTab={activeTab === 'phoneTab'}
          isVehicleTab={isVehicleTab}
          setIsVINModalOpen={setIsVINModalOpen}
        />
      </SearchHubContainer>

      {displayDisclaimer && (
        <DisclaimerText>
          <FcraWarning
            fcraLink={fcraLink}
            tosLink={tosLink}
            brandName={brandName}
          />
        </DisclaimerText>
      )}

      <WhereIsMyVINModal
        isOpen={isVINModalOpen}
        handleClose={() => {
          setIsVINModalOpen(false);
        }}
      />
    </Stack>
  );
};
